import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Globals } from 'src/app/globals';

@Component({
    selector: 'header',
    templateUrl: './header.component.html'
})
export class HeaderComponent implements OnInit{
    isShowMenu: boolean = false;
    constructor(public route: ActivatedRoute, private router: Router, public globals: Globals) { }
    ngOnInit(): void {
        if(sessionStorage.getItem("menu") != null && sessionStorage.getItem("menu") != '' && sessionStorage.getItem("menu") != undefined && sessionStorage.getItem("menu") != "no") {
            this.isShowMenu = true;
        } else {
            this.isShowMenu = false;
        }
    }
}